<ng-template #content let-c="close" let-d="dismiss">
    <div class="modal-header">
        <h6 class="modal-title" translate>TITLE.TITLE_PLEASE_CONFIRM</h6>
    </div>
    <div class="modal-body">
        <span>{{'LBL.DELETE_CONFIRM' | translate}} {{Model}}?</span>
    </div>
    <div class="modal-footer">
        <button type="submit" class="btn btn-primary mr-3" (click)="DisableModalOpenEvent = false; Delete()" translate>BTN.BTN_YES</button>
        <button type="button" class="btn btn-secondary" (click)="DisableModalOpenEvent = false; c('close')" translate>BTN.BTN_NO</button>
    </div>
</ng-template>
